(function () {
  'use strict';
  if (window.EnigmaCartDrawerUI) return;
  var noteDraft = null, couponDraft = null, savedCoupon = '';
  document.addEventListener('click', async function (event) {
    var button = event.target.closest('[data-cart-share]');
    if (!button) return;
    event.preventDefault();
    if (button.disabled || document.documentElement.hasAttribute('data-cart-mutating')) return;
    var canvas = button.closest('.block_cart_canvas');
    var status = canvas.querySelector('[data-cart-share-status]');
    var english = document.documentElement.lang.indexOf('en') === 0;
    function say(it, en) { if (status) status.textContent = english ? en : it; }
    button.disabled = true;
    try {
      var response = await fetch(canvas.getAttribute('data-cart-json-url') || '/cart.js', { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) throw new Error('cart');
      var cart = await response.json();
      if (!cart.items || !cart.items.length) { say('Il carrello è vuoto.', 'Your cart is empty.'); return; }
      var quantities = new Map();
      cart.items.forEach(function (item) {
        var id = String(item.variant_id);
        if (!/^\d+$/.test(id) || !Number.isInteger(item.quantity) || item.quantity < 1) throw new Error('item');
        quantities.set(id, (quantities.get(id) || 0) + item.quantity);
      });
      var lines = Array.from(quantities, function (entry) { return entry[0] + ':' + entry[1]; }).join(',');
      var url = new URL((canvas.getAttribute('data-cart-url') || '/cart').replace(/\/$/, '') + '/' + lines, location.origin);
      url.searchParams.set('storefront', 'true');
      var share = { title: english ? 'My Enigma cart' : 'Il mio carrello Enigma', url: url.href };
      if (navigator.share) {
        try { await navigator.share(share); say('Carrello condiviso.', 'Cart shared.'); return; }
        catch (error) { if (error.name === 'AbortError') return; }
      }
      try {
        await navigator.clipboard.writeText(url.href);
        say('Link del carrello copiato.', 'Cart link copied.');
      } catch (error) {
        window.prompt(english ? 'Copy your cart link:' : 'Copia il link del carrello:', url.href);
      }
    } catch (error) {
      say('Impossibile condividere il carrello. Riprova.', 'Unable to share your cart. Please try again.');
    } finally { button.disabled = false; }
  });
  function root() { return document.querySelector('[data-enigma-drawer-tools]'); }
  function cookieCode() {
    return window.jQuery && typeof window.jQuery.cookie === 'function' ? window.jQuery.cookie('discountCode') || '' : '';
  }
  function sync() {
    var tools = root();
    if (!tools) return;
    var note = tools.querySelector('[data-drawer-note]'), coupon = tools.querySelector('[data-drawer-discount]');
    if (note) { if (noteDraft === null) noteDraft = note.value; else note.value = noteDraft; }
    if (coupon) {
      if (couponDraft === null) savedCoupon = couponDraft = cookieCode();
      coupon.value = couponDraft;
      var hidden = tools.closest('form').querySelector('.js-form-discount');
      if (hidden) hidden.value = savedCoupon;
    }
  }
  function show(tools, name, focus) {
    tools.querySelectorAll('[data-drawer-tool]').forEach(function (button) {
      button.setAttribute('aria-expanded', String(button.dataset.drawerTool === name));
    });
    tools.querySelectorAll('[data-drawer-tool-panel]').forEach(function (panel) {
      panel.hidden = panel.dataset.drawerToolPanel !== name;
      if (!panel.hidden && focus) panel.querySelector('input,textarea').focus();
    });
  }
  function close(tools, panel) {
    show(tools, '', false);
    tools.querySelector('[data-drawer-tool="' + panel.dataset.drawerToolPanel + '"]').focus();
  }
  function saveCoupon(tools, panel) {
    savedCoupon = couponDraft = panel.querySelector('[data-drawer-discount]').value.trim();
    document.querySelectorAll('.js-form-discount, [data-cart-page-discount], .cart_extend--input[name="discount"]').forEach(function (field) { field.value = savedCoupon; });
    if (window.jQuery && typeof window.jQuery.cookie === 'function') window.jQuery.cookie('discountCode', savedCoupon, 30);
    document.dispatchEvent(new CustomEvent('enigma:cart-coupon-saved', { detail: { code: savedCoupon } }));
    close(tools, panel);
  }
  document.addEventListener('input', function (event) {
    if (event.target.matches('[data-drawer-note]')) noteDraft = event.target.value;
    if (event.target.matches('[data-drawer-discount]')) couponDraft = event.target.value;
  });
  document.addEventListener('click', function (event) {
    var tools = event.target.closest('[data-enigma-drawer-tools]');
    if (!tools) return;
    var toggle = event.target.closest('[data-drawer-tool]');
    if (toggle) { show(tools, toggle.getAttribute('aria-expanded') === 'true' ? '' : toggle.dataset.drawerTool, true); return; }
    var panel = event.target.closest('[data-drawer-tool-panel]');
    if (!panel) return;
    if (event.target.closest('[data-drawer-discount-save]')) saveCoupon(tools, panel);
    if (event.target.closest('[data-drawer-tool-cancel]')) {
      if (panel.dataset.drawerToolPanel === 'note') {
        var note = panel.querySelector('textarea'); noteDraft = note.value = note.defaultValue;
      } else { couponDraft = panel.querySelector('input').value = savedCoupon; }
      close(tools, panel);
    }
    if (event.target.closest('[data-drawer-note-save]') && document.documentElement.hasAttribute('data-cart-mutating')) event.preventDefault();
  });
  document.addEventListener('keydown', function (event) {
    var panel = event.target.closest('[data-drawer-tool-panel]');
    if (!panel || panel.hidden) return;
    if (event.key === 'Escape') { event.preventDefault(); close(panel.closest('[data-enigma-drawer-tools]'), panel); }
    if (event.key === 'Enter' && event.target.matches('[data-drawer-discount]')) { event.preventDefault(); saveCoupon(panel.closest('[data-enigma-drawer-tools]'), panel); }
  });
  document.addEventListener('enigma:cart-coupon-saved', function (event) {
    savedCoupon = couponDraft = event.detail.code || ''; sync();
  });
  document.addEventListener('enigma:cart-updated', sync);
  document.addEventListener('shopify:section:load', sync);
  window.EnigmaCartDrawerUI = { sync: sync };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync); else sync();
})();
